module.exports = __webpack_public_path__ + "static/mr-press-19-14d431e5a64c6008f0811332de0a21c0.jpg";